import React from 'react';
import { Box, Typography } from '@mui/material';

export const LoadingView : React.FC = () => {
    return <Box flexDirection={'column'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'80vh'}>
        <img style={{maxHeight: '250px', maxWidth: '250px'}} src={'/icons/load-35.gif'} alt={'loading'} />
        <Typography variant={'body2'}>Loading...</Typography>
    </Box>;
};   